import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { AccountsInfo } from '../../../common/dtos/accounts-info.dto';
import { ClientSegmentContentDTO } from '../../../common/dtos/client-segment.dto';

export const accountUsersDataLoadedSuccess = createAction(
    '[Account Permission API] Account Users Permission Loaded Success',
    props<{ data: AccountsInfo }>(),
);

export const accountUsersDataLoadedError = createAction(
    '[Account Permission API] Account Users Permission Loaded Error',
    props<{ error: HttpErrorResponse }>(),
);

export const clientSegmentContentLoadedSuccess = createAction(
    '[Account Permission API] Client Segment Content Loaded Success',
    props<{ data: ClientSegmentContentDTO }>(),
);

export const clientSegmentContentLoadedError = createAction(
    '[Account Permission API] Client Segment Content Loaded Error',
    props<{ error: HttpErrorResponse }>(),
);

export const clientSegmentContentLoadedRedirect = createAction(
    '[Account Permission API] Client Segment Content Loaded Redirect',
    props<{ error: HttpErrorResponse }>(),
);
